import React from 'react';
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import PhonelinkEraseIcon from "@mui/icons-material/PhonelinkErase";
import CharacteristicsSelector from "../characteristics/CharacteristicsSelector";

const drawerWidth = "auto";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

/**
 * FilterDrawer - Sidebar drawer for selecting search characteristics
 * @param {boolean} open - Whether the drawer is open
 * @param {Function} onClose - Handler for closing drawer without applying
 * @param {Function} onApply - Handler for applying filters and closing
 * @param {Function} onClear - Handler for clearing all filters
 * @param {Map} enumMap - Current characteristics selection map
 */
export default function FilterDrawer({
  open,
  onClose,
  onApply,
  onClear,
  enumMap
}) {
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          marginTop: '64px', // Default AppBar height
          height: 'calc(100% - 64px)', // Subtract AppBar height
          zIndex: (theme) => theme.zIndex.appBar - 1, // Below AppBar
        },
      }}
      variant="temporary"
      anchor="left"
      open={open}
      onClose={onClose}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile
      }}
    >
      <DrawerHeader>
        <Grid container spacing={2}>
          <Grid item xs={1}>
            <IconButton disabled={false} onClick={onClear}>
              <PhonelinkEraseIcon />
            </IconButton>
          </Grid>
        </Grid>
        <IconButton onClick={onClose}>
          <ArrowBackIcon fontSize="large" />
        </IconButton>
        <IconButton onClick={onApply}>
          <FaceRetouchingNaturalIcon
            fontSize="large"
            sx={{ color: "#2d3e50" }}
          />
        </IconButton>
      </DrawerHeader>
      <Divider />
      <CharacteristicsSelector enumMap={enumMap} />
    </Drawer>
  );
}
